import {Observable} from 'rxjs';
import {MimeType} from '../enum/mime-type.enum';

export function formatFileSize(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  while (bytes >= 1024 && i < units.length - 1) {
    bytes /= 1024;
    i++;
  }
  return new Intl.NumberFormat('en', {maximumFractionDigits: 2}).format(bytes) + ' ' + units[i];
}

/**
 *
 * @param acceptedFiles comma separated list of file extensions
 */
export function openFileSelect(acceptedFiles?: string | null): Observable<FileList | null> {
  return new Observable<FileList | null>((subscriber) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = acceptedFiles ?? '*/*';
    fileInput.onchange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      subscriber.next(target.files);
      subscriber.complete();
    };
    fileInput.click();
  });
}

export function getExtensionByMimeType(mimeType: MimeType | string): string | null {
  if (!mimeType || !Object.values(MimeType).includes(mimeType as MimeType)) {
    return null;
  }
  const mimeTypeMapping: Record<MimeType, string> = {
    [MimeType.PDF]: 'pdf',
    [MimeType.JPEG_IMAGE]: 'jpeg',
    [MimeType.PNG_IMAGE]: 'png',
    [MimeType.GIF_IMAGE]: 'gif',
    [MimeType.TEXT_FILE]: 'txt',
    [MimeType.JSON]: 'json',
    [MimeType.ZIP_ARCHIVE]: 'zip',
    [MimeType.CSV]: 'csv',
    [MimeType.MP4_VIDEO]: 'mp4',
    [MimeType.DOC]: 'doc',
    [MimeType.DOCX]: 'docx',
    [MimeType.XLS]: 'xls',
    [MimeType.XLSX]: 'xlsx',
  };

  return mimeTypeMapping[mimeType as MimeType];
}
